<template>
  <div id="io">
    <div class="buttons" v-show="open">
      <Button @click="activateDialog('importRaw')">Import raw text</Button>
      <Button @click="activateDialog('importFile')">Import from file</Button>
      <Button
        v-if="this.languages.length !== 0"
        @click="activateDialog('exportRaw')"
        >Export raw text</Button
      >
      <Button
        v-if="this.languages.length !== 0"
        :href="''"
        @click="exportToFile"
        >Export to file</Button
      >
    </div>
    <Button id="io-toggle" @click="toggleMenuOpen">Save/Load</Button>

    <Dialog
      v-if="activeDialog === 'importRaw'"
      id="import-raw"
      title="Import Raw Text"
      :buttons="true"
      okText="Import"
      @ok="parseRawText"
      @cancel="closeDialog"
    >
      <p>
        Type or copy in plaintext into the field below. Then press "Import" to
        import the raw text into Metaphrase. This will separate the text into
        paragraphs.
      </p>
      <p>
        Importing text will overwrite any work you currently have on page. If
        you don't want this, press "Cancel".
      </p>
      <textarea
        name="raw-text"
        v-model="rawTextImport"
        placeholder="Write/paste your text content in here."
      ></textarea>
      <br />
      <input
        type="text"
        placeholder="Language of this text"
        name="language-of-text"
        v-model="originalLanguage"
      />
    </Dialog>

    <Dialog
      v-if="activeDialog === 'importFile'"
      title="Import from file"
      :buttons="true"
      okText="Import"
      @ok="importFromFile"
      @cancel="closeDialog"
    >
      <p>
        Import a `metaphrase.json` file that you've previously saved.
      </p>
      <input
        id="file-selection"
        type="file"
        accept=".metaphrase.json"
        @change="handleFileSelection"
      />
    </Dialog>

    <Dialog
      v-if="activeDialog === 'exportRaw'"
      id="export-raw"
      title="Export raw text"
      @cancel="closeDialog"
    >
      <p>
        Here is your text, back in raw text form! Ready to be copied into
        another document.
      </p>
      <div
        v-for="(text, index) in rawTextExports"
        :key="index"
        class="raw-text-block"
      >
        <label :for="Object.keys(text)[0]">{{ Object.keys(text)[0] }}</label>
        <textarea
          :name="Object.keys(text)[0]"
          :value="text[Object.keys(text)[0]]"
        >
        </textarea>
      </div>
    </Dialog>
  </div>
</template>

<script>
export default {
  name: "IO",
  props: {
    title: String,
    paragraphs: Object,
    paragraphOrder: Array,
    languages: Array
  },
  data() {
    return {
      open: true,
      rawTextImport: "",
      originalLanguage: "",
      activeDialog: "",
      selectedFile: null
    };
  },
  computed: {
    rawTextExports() {
      return this.languages.map(language => {
        return {
          [language]: this.paragraphOrder
            .map(id => {
              return this.paragraphs[id][language];
            })
            .join("\n\n")
        };
      });
    }
  },
  methods: {
    // UI
    toggleMenuOpen() {
      this.open = !this.open;
    },
    activateDialog(name) {
      this.activeDialog = name;
    },
    closeDialog() {
      this.activeDialog = "";
    },

    // Text/file processing
    parseRawText() {
      if (!this.originalLanguage || !this.rawTextImport) return;

      const pars = {};
      this.rawTextImport.split("\n").forEach((paragraph, index) => {
        if (!paragraph) return;

        pars[index] = {
          [this.originalLanguage]: paragraph,
          order: index
        };
      });

      this.$emit("initParagraphs", {
        title: "",
        paragraphs: pars
      });
      this.closeDialog();
    },
    handleFileSelection(ev) {
      this.selectedFile = ev.target.files[0];
    },
    importFromFile() {
      const reader = new FileReader();
      reader.onload = ev => {
        this.$emit("initParagraphs", JSON.parse(ev.target.result));
        this.closeDialog();
      };
      reader.readAsText(this.selectedFile);
    },
    exportToFile(ev) {
      ev.target.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," +
          encodeURIComponent(
            JSON.stringify({
              title: this.title,
              paragraphs: this.paragraphs
            })
          )
      );
      ev.target.setAttribute(
        "download",
        `${this.title.split(" ").join("-") || "document"}.metaphrase.json`
      );
    }
  }
};
</script>

<style>
#io {
  position: absolute;
  right: 0;
  top: 0;
  padding: 10px 5px;
}
.buttons,
#io-toggle {
  display: inline-block;
}
#io > .buttons {
  padding-right: 10px;
  margin-right: 10px;
  border-right: 1px solid;
}
#io > .buttons > .m-button,
#io-toggle {
  margin: 0 5px;
}

/* Dialogs */
#io .m-dialog textarea {
  display: block;
  width: 100%;
  min-height: 10rem;
}
#import-raw input {
  width: 100%;
}
#export-raw .raw-text-block {
  margin: 20px 0;
}
</style>
